var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container",attrs:{"id":"errors"}},[(_vm.error)?_c('div',{staticClass:"alert error"},[_c('h3',[_vm._v(_vm._s(_vm.error.detail.title))]),_vm._v(_vm._s(_vm.error.detail.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }